import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Field from "../components/Field";
import { FileUpload, Select, Text } from "../inputs";
import { Form } from "../template";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import { useApp } from "../providers/app";
import Status from "./Status";

const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { user } = useApp();

  const props = {
    editable: false,
    isDeletable: false,
    model: "order",
    text: id ? "订单信息" : "注册商标",
    id: id,
    init: {},
    validationSchema: Yup.object().shape({}),
  };
  const beforeSubmit = async (data) => {
    return data;
  };
  return (
    <Form {...props} beforeSubmit={beforeSubmit}>
      {({ submited, disabled, values }) => {
        const list = objectPath.get(values, "list");
        const status = objectPath.get(values, "status");
        const factory = objectPath.get(values, "factory");
        const description = objectPath.get(values, "description");
        return (
          <div className="flex flex-col w-full mb-96">
            <div className="p-5 bg-white  grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex flex-col gap-4">
                <div>{t("order.name")}</div>

                <div className="flex flex-col">
                  {list?.map((row, index) => {
                    const name = objectPath.get(row, "name");
                    const size = objectPath.get(row, "sizeObj.name");
                    const material = objectPath.get(row, "materialObj.name");
                    const count = objectPath.get(row, "count");
                    const price = objectPath.get(row, "price");
                    const total = objectPath.get(row, "total_price");

                    const url = API_ROOT + "/" + objectPath.get(row, "image");
                    return (
                      <div key={index} className="flex flex-col mt-2">
                        <div className="flex justify-between items-center border-b pb-2">
                          <div className="font-bold">{`${index + 1}. ${
                            name == "special" ? t(`special`) : name
                          }`}</div>
                        </div>
                        <div className="flex flex-col md:flex-row mt-2 items-center">
                          <img
                            className="w-32 rounded-md"
                            src={url}
                            crossOrigin="anonymous"
                          />

                          <div className="pl-4">
                            <div>{material}</div>
                            <div>{size}</div>
                          </div>
                          <div className="text-2xl mx-4">x</div>
                          <div className="flex flex-col mx-4 justify-center items-center">
                            <div className="font-bold text-center">{`${count} ш`}</div>
                            <div className=" text-center">{`${price} ¥`}</div>
                          </div>
                          <div className="text-2xl mx-4"> = </div>
                          <div className="">
                            <div>{`${total} ¥`}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <Field
                  name="company"
                  label={t("order.company")}
                  disabled={disabled}
                  component={Text}
                />
                <Field
                  name="companyno"
                  label={t("order.companyno")}
                  disabled={disabled}
                  component={Text}
                />
                <Field
                  name="name"
                  label={t("order.user")}
                  disabled={disabled}
                  component={Text}
                />
                <Field
                  name="email"
                  label={t("order.email")}
                  disabled={disabled}
                  component={Text}
                />
                <Field
                  name="phone"
                  label={t("order.name")}
                  disabled={disabled}
                  component={Text}
                />
                <Field
                  name="grandTotal"
                  label={t("order.grandtotal")}
                  disabled={disabled}
                  component={Text}
                />

                <Field
                  name="description"
                  label={t("order.description")}
                  disabled={disabled}
                  component={Text}
                  type="textarea"
                />
              </div>
            </div>
            <Status
              id={id}
              current_status={status}
              factory_user={factory}
              description={description}
            />
          </div>
        );
      }}
    </Form>
  );
};

export default UserForm;
